export default __webpack_public_path__ + "static/media/Group 2820@2x.ca49843b.png";